import {
  Companion_getInstance1twm7uvvfawb7 as Companion_getInstance,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_timestamp(_this__u8e3s4) {
  return _this__u8e3s4.prop(AccessInfo_timestamp_getInstance());
}
function prepareAccessInfoFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [AccessInfo_user_getInstance(), AccessInfo_ip_getInstance(), AccessInfo_sessionId_getInstance(), AccessInfo_userAgent_getInstance(), AccessInfo_timestamp_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function AccessInfo_timestamp$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function AccessInfo_timestamp$_get_name_$ref_mn3fiu() {
  return (p0) => p0.k20();
}
function AccessInfo_timestamp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessInfo_timestamp$_get_serializer_$ref_1berr7() {
  return (p0) => p0.j2j();
}
function AccessInfo_timestamp$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function AccessInfo_timestamp$_get_annotations_$ref_oq0twh() {
  return (p0) => p0.bz();
}
var AccessInfo_timestampClass;
function AccessInfo_timestamp() {
  if (AccessInfo_timestampClass === VOID) {
    class $ {
      constructor() {
        AccessInfo_timestamp_instance = this;
        var tmp = this;
        tmp.i54_1 = lazy(AccessInfo_timestamp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j54_1 = lazy(AccessInfo_timestamp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k54_1 = lazy(AccessInfo_timestamp$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.i54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessInfo_timestamp$_get_name_$ref_mn3fiu(), null);
        return tmp0.f2();
      }
      l54(receiver) {
        return receiver.q54_1;
      }
      m2j(receiver) {
        return this.l54(receiver instanceof AccessInfo() ? receiver : THROW_CCE());
      }
      r54(receiver, value) {
        return receiver.s54(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessInfo() ? receiver : THROW_CCE();
        return this.r54(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessInfo_timestamp$_get_serializer_$ref_1berr7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessInfo_timestamp$_get_annotations_$ref_oq0twh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessInfo_timestamp', VOID, VOID, [SerializableProperty()]);
    AccessInfo_timestampClass = $;
  }
  return AccessInfo_timestampClass;
}
var AccessInfo_timestamp_instance;
function AccessInfo_timestamp_getInstance() {
  if (AccessInfo_timestamp_instance === VOID)
    new (AccessInfo_timestamp())();
  return AccessInfo_timestamp_instance;
}
function AccessInfo_user$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function AccessInfo_user$_get_name_$ref_lsp55x() {
  return (p0) => p0.k20();
}
function AccessInfo_user$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessInfo_user$_get_serializer_$ref_fn03ec() {
  return (p0) => p0.j2j();
}
function AccessInfo_user$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function AccessInfo_user$_get_annotations_$ref_siej00() {
  return (p0) => p0.bz();
}
var AccessInfo_userClass;
function AccessInfo_user() {
  if (AccessInfo_userClass === VOID) {
    class $ {
      constructor() {
        AccessInfo_user_instance = this;
        var tmp = this;
        tmp.t54_1 = lazy(AccessInfo_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u54_1 = lazy(AccessInfo_user$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v54_1 = lazy(AccessInfo_user$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessInfo_user$_get_name_$ref_lsp55x(), null);
        return tmp0.f2();
      }
      l54(receiver) {
        return receiver.m54_1;
      }
      m2j(receiver) {
        return this.l54(receiver instanceof AccessInfo() ? receiver : THROW_CCE());
      }
      w54(receiver, value) {
        return receiver.s54(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessInfo() ? receiver : THROW_CCE();
        return this.w54(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessInfo_user$_get_serializer_$ref_fn03ec(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessInfo_user$_get_annotations_$ref_siej00(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessInfo_user', VOID, VOID, [SerializableProperty()]);
    AccessInfo_userClass = $;
  }
  return AccessInfo_userClass;
}
var AccessInfo_user_instance;
function AccessInfo_user_getInstance() {
  if (AccessInfo_user_instance === VOID)
    new (AccessInfo_user())();
  return AccessInfo_user_instance;
}
function AccessInfo_ip$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function AccessInfo_ip$_get_name_$ref_4yol1d() {
  return (p0) => p0.k20();
}
function AccessInfo_ip$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessInfo_ip$_get_serializer_$ref_2qcwrs() {
  return (p0) => p0.j2j();
}
function AccessInfo_ip$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function AccessInfo_ip$_get_annotations_$ref_trp8gk() {
  return (p0) => p0.bz();
}
var AccessInfo_ipClass;
function AccessInfo_ip() {
  if (AccessInfo_ipClass === VOID) {
    class $ {
      constructor() {
        AccessInfo_ip_instance = this;
        var tmp = this;
        tmp.x54_1 = lazy(AccessInfo_ip$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y54_1 = lazy(AccessInfo_ip$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z54_1 = lazy(AccessInfo_ip$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessInfo_ip$_get_name_$ref_4yol1d(), null);
        return tmp0.f2();
      }
      l54(receiver) {
        return receiver.n54_1;
      }
      m2j(receiver) {
        return this.l54(receiver instanceof AccessInfo() ? receiver : THROW_CCE());
      }
      a55(receiver, value) {
        return receiver.s54(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessInfo() ? receiver : THROW_CCE();
        return this.a55(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessInfo_ip$_get_serializer_$ref_2qcwrs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessInfo_ip$_get_annotations_$ref_trp8gk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessInfo_ip', VOID, VOID, [SerializableProperty()]);
    AccessInfo_ipClass = $;
  }
  return AccessInfo_ipClass;
}
var AccessInfo_ip_instance;
function AccessInfo_ip_getInstance() {
  if (AccessInfo_ip_instance === VOID)
    new (AccessInfo_ip())();
  return AccessInfo_ip_instance;
}
function AccessInfo_sessionId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function AccessInfo_sessionId$_get_name_$ref_qyel8v() {
  return (p0) => p0.k20();
}
function AccessInfo_sessionId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessInfo_sessionId$_get_serializer_$ref_vr49co() {
  return (p0) => p0.j2j();
}
function AccessInfo_sessionId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function AccessInfo_sessionId$_get_annotations_$ref_60scro() {
  return (p0) => p0.bz();
}
var AccessInfo_sessionIdClass;
function AccessInfo_sessionId() {
  if (AccessInfo_sessionIdClass === VOID) {
    class $ {
      constructor() {
        AccessInfo_sessionId_instance = this;
        var tmp = this;
        tmp.b55_1 = lazy(AccessInfo_sessionId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c55_1 = lazy(AccessInfo_sessionId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d55_1 = lazy(AccessInfo_sessionId$annotations$delegate$lambda);
        this.e55_1 = null;
        this.f55_1 = 'null';
      }
      k20() {
        var tmp0 = this.b55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessInfo_sessionId$_get_name_$ref_qyel8v(), null);
        return tmp0.f2();
      }
      l54(receiver) {
        return receiver.o54_1;
      }
      m2j(receiver) {
        return this.l54(receiver instanceof AccessInfo() ? receiver : THROW_CCE());
      }
      g55(receiver, value) {
        return receiver.s54(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessInfo() ? receiver : THROW_CCE();
        return this.g55(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessInfo_sessionId$_get_serializer_$ref_vr49co(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessInfo_sessionId$_get_annotations_$ref_60scro(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessInfo_sessionId', VOID, VOID, [SerializableProperty()]);
    AccessInfo_sessionIdClass = $;
  }
  return AccessInfo_sessionIdClass;
}
var AccessInfo_sessionId_instance;
function AccessInfo_sessionId_getInstance() {
  if (AccessInfo_sessionId_instance === VOID)
    new (AccessInfo_sessionId())();
  return AccessInfo_sessionId_instance;
}
function AccessInfo_userAgent$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function AccessInfo_userAgent$_get_name_$ref_g29f0m() {
  return (p0) => p0.k20();
}
function AccessInfo_userAgent$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessInfo_userAgent$_get_serializer_$ref_jkjv6n() {
  return (p0) => p0.j2j();
}
function AccessInfo_userAgent$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function AccessInfo_userAgent$_get_annotations_$ref_mciced() {
  return (p0) => p0.bz();
}
var AccessInfo_userAgentClass;
function AccessInfo_userAgent() {
  if (AccessInfo_userAgentClass === VOID) {
    class $ {
      constructor() {
        AccessInfo_userAgent_instance = this;
        var tmp = this;
        tmp.h55_1 = lazy(AccessInfo_userAgent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i55_1 = lazy(AccessInfo_userAgent$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j55_1 = lazy(AccessInfo_userAgent$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessInfo_userAgent$_get_name_$ref_g29f0m(), null);
        return tmp0.f2();
      }
      l54(receiver) {
        return receiver.p54_1;
      }
      m2j(receiver) {
        return this.l54(receiver instanceof AccessInfo() ? receiver : THROW_CCE());
      }
      a55(receiver, value) {
        return receiver.s54(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessInfo() ? receiver : THROW_CCE();
        return this.a55(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessInfo_userAgent$_get_serializer_$ref_jkjv6n(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j55_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessInfo_userAgent$_get_annotations_$ref_mciced(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessInfo_userAgent', VOID, VOID, [SerializableProperty()]);
    AccessInfo_userAgentClass = $;
  }
  return AccessInfo_userAgentClass;
}
var AccessInfo_userAgent_instance;
function AccessInfo_userAgent_getInstance() {
  if (AccessInfo_userAgent_instance === VOID)
    new (AccessInfo_userAgent())();
  return AccessInfo_userAgent_instance;
}
//region block: exports
export {
  prepareAccessInfoFields as prepareAccessInfoFields1zroiczk1n32t,
  get_timestamp as get_timestamp2nq1ys1aq8dif,
};
//endregion

//# sourceMappingURL=AccessInfoFields.mjs.map
